import { Routes } from '@angular/router';

export const EMPLOYEES_ROUTES: Routes = [
    {
        path: 'employees',
        title: 'Employees',
        data: {
            icon: 'people',
            module: 'EMPLOYEE',
        },
        loadComponent: () => import('./employees.component').then((m) => m.EmployeesComponent),
        children: [
            {
               path: ':id/edit-employee',
               title: 'Employee Details',
               loadComponent: () => import('../employees/employee-edit/employee-edit.component').then((m) => m.EmployeeEditComponent),
            },
            {
                path: '',
                pathMatch: 'full',
                data: {
                    reuse: true,
                },
                loadComponent: () => import('./employee-list/employee-list.component').then((m) => m.EmployeeListComponent),
            },
        ]
    },
];
